import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import Select from 'react-select-plus';
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';

class ComponentAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `SMS Templete`;
    this.moduleUrl = `setting/smsTemplete`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = '') {
    editData = editData || {};
    this.state = {
      name: editData.name || '',
      type: editData.type || 'text',
      templete: editData.templete || ''
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      Alert.success(`${data.message}`);
      this.setData();
      this.props.closeModal(true);
    } else {
      Alert.error(`${data.message}`);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
    let tData = {
      name: this.state.name,
      type: this.state.type,
      templete: this.state.templete
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.setData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        data => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} is Created.`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { modalType } = this.props;
    return (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('name', {
              defaultValue: '',
              autoFocus: true,
              required: true,
              id: 'name',
              value: this.state.name,
              onChange: e => {
                this.setState({ name: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('templete', {
              defaultValue: '',
              autoFocus: false,
              required: true,
              id: 'templete',
              type: 'textArea',
              value: this.state.templete,
              onChange: e => {
                this.setState({ templete: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <ModalFooter modalType={modalType}>
          <Button
            btnStyle="cancel"
            onClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </Button>
        </ModalFooter>
      </form>
    );
  }
}

ComponentAddEdit.propTypes = {
  group: PropTypes.array
};

ComponentAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired
};

export default ComponentAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsAppProvider/components/ComponentAddEdit.js